import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { MarketingRoutingModule } from './marketing-routing.module';
import { MarketingComponent } from './marketing/marketing.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { RewardsCatalogComponent } from './rewards-catalog/rewards-catalog.component';
import { MarketingService } from '../../../../shared/_services/marketing.service';
import { RewardsCatalogNewRewardComponent } from './rewards-catalog-new-reward/rewards-catalog-new-reward.component';
import { PromotionsNewPromoComponent } from './promotions-new-promo/promotions-new-promo.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MarketingRoutingModule
  ],
  providers: [MarketingService],
  declarations: [MarketingComponent, PromotionsComponent, RewardsCatalogComponent, RewardsCatalogNewRewardComponent, PromotionsNewPromoComponent]
})
export class MarketingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/marketing.module.ts